import { SetURLSearchParams } from 'react-router-dom'
import {
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  Select,
  Space,
  Typography,
} from 'antd'
import {
  PERIOD_OPTIONS,
  PERIOD_VALUES,
} from 'src/pages/billing/paymentTrafficMonitoring/const'
import { resetMonitoringList } from 'src/pages/billing/paymentTrafficMonitoring/model'
import { ValueFormFilter } from 'src/pages/billing/paymentTrafficMonitoring/types'
import { normalizeDate } from 'src/pages/billing/paymentTrafficMonitoring/utils'

type Props = {
  setSearchParams: SetURLSearchParams
  initialValues: ValueFormFilter
  resetSearchParams: () => void
}

export const FilterMonitoring = ({
  setSearchParams,
  initialValues,
  resetSearchParams,
}: Props) => {
  const [form] = Form.useForm()
  const { Item } = Form
  const { RangePicker } = DatePicker
  const { Text } = Typography

  const handleChangeForm = (valueField: Record<string, any>) => {
    const [key, value] = Object.entries(valueField)[0]

    if (key === 'preset' && value === 'date_range') {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev)

        params.delete('preset')
        params.delete('dateFrom')
        params.delete('dateTo')

        return params
      })

      resetMonitoringList()

      setTimeout(() => {
        form.validateFields(['periodDatePicker']).catch(() => {})
      }, 0)

      return
    }

    if (key === 'periodDatePicker') {
      const [dateFromPicker, dateToPicker] = value ?? []

      setSearchParams((prev) => {
        const params = new URLSearchParams(prev)
        params.delete('page')
        params.set('dateFrom', normalizeDate(dateFromPicker))
        params.set('dateTo', normalizeDate(dateToPicker))

        return params
      })
      return
    }

    if (key === 'preset') {
      form.setFieldValue('periodDatePicker', undefined)
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev)

        params.delete('page')
        params.delete('dateFrom')
        params.delete('dateTo')
        params.set('preset', value)

        return params
      })
      return
    }
  }

  const handleReset = () => {
    resetSearchParams()
    form.setFieldValue('direction', undefined)
    form.setFieldValue('periodDatePicker', undefined)
    form.setFieldValue('preset', PERIOD_VALUES.LAST_30_MINUTES)
  }

  const presetForm = Form.useWatch('preset', form)
  const direction = Form.useWatch('direction', form)
  const canResetFilters =
    direction || presetForm !== PERIOD_VALUES.LAST_30_MINUTES

  return (
    <Card>
      <Flex gap={8}>
        <Form
          form={form}
          layout="inline"
          onValuesChange={handleChangeForm}
          initialValues={initialValues}
        >
          <Flex align="center" gap={8}>
            <Text style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
              Тип Транзакции
            </Text>

            <Item name="direction">
              <Space.Compact>
                <Button
                  color={direction === 'deposit' ? 'blue' : 'default'}
                  type={direction === 'deposit' ? 'primary' : 'default'}
                  onClick={() => {
                    const newValue =
                      direction === 'deposit' ? undefined : 'deposit'
                    form.setFieldValue('direction', newValue)

                    setSearchParams((prev) => {
                      const params = new URLSearchParams(prev)

                      if (newValue) {
                        params.set('direction', newValue)
                        params.delete('page')
                      } else {
                        params.delete('direction')
                      }

                      return params
                    })
                  }}
                >
                  Deposits
                </Button>

                <Button
                  color={direction === 'withdrawal' ? 'blue' : 'default'}
                  type={direction === 'withdrawal' ? 'primary' : 'default'}
                  onClick={() => {
                    const newValue =
                      direction === 'withdrawal' ? undefined : 'withdrawal'
                    form.setFieldValue('direction', newValue)

                    setSearchParams((prev) => {
                      const params = new URLSearchParams(prev)

                      if (newValue) {
                        params.set('direction', newValue)
                        params.delete('page')
                      } else {
                        params.delete('direction')
                      }

                      return params
                    })
                  }}
                >
                  Withdrawals
                </Button>
              </Space.Compact>
            </Item>
          </Flex>

          <Item name="preset" style={{ width: 170 }}>
            <Select placeholder="Period" options={PERIOD_OPTIONS} />
          </Item>

          {presetForm === 'date_range' && (
            <Item
              name="periodDatePicker"
              style={{ height: 30 }}
              rules={[
                {
                  required: true,
                  message: 'Required field',
                },
              ]}
            >
              <RangePicker style={{ width: 250 }} />
            </Item>
          )}
        </Form>
        {canResetFilters && (
          <Button onClick={handleReset}>Reset Filters</Button>
        )}
      </Flex>
    </Card>
  )
}
